<!DOCTYPE html>
<html lang="en">

<head>
  <meta charset="utf-8">
  <meta content="width=device-width, initial-scale=1.0" name="viewport">

  <title>Blog Single - Company Bootstrap Template</title>
  <meta content="" name="description">
  <meta content="" name="keywords">

  <!-- Favicons -->
  <link href="/assets/img/favicon.png" rel="icon">
  <link href="/assets/img/apple-touch-icon.png" rel="apple-touch-icon">

  <!-- Google Fonts -->
  <link
    href="https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i|Roboto:300,300i,400,400i,500,500i,600,600i,700,700i|Poppins:300,300i,400,400i,500,500i,600,600i,700,700i"
    rel="stylesheet">

  <!-- Vendor CSS Files -->
  <link href="/assets/vendor/animate.css/animate.min.css" rel="stylesheet">
  <link href="/assets/vendor/aos/aos.css" rel="stylesheet">
  <link href="/assets/vendor/bootstrap/css/bootstrap.min.css" rel="stylesheet">
  <link href="/assets/vendor/bootstrap-icons/bootstrap-icons.css" rel="stylesheet">
  <link href="/assets/vendor/boxicons/css/boxicons.min.css" rel="stylesheet">
  <link href="/assets/vendor/glightbox/css/glightbox.min.css" rel="stylesheet">
  <link href="/assets/vendor/remixicon/remixicon.css" rel="stylesheet">
  <link href="/assets/vendor/swiper/swiper-bundle.min.css" rel="stylesheet">

  <!-- Template Main CSS File -->
  <link href="/assets/css/style.css" rel="stylesheet">

</head>

<body>
  <main id="main">

    <section id="blog" class="blog">
      <div style="margin-top: 150px;" class="container" data-aos="fade-up">

        <div class="row">

          <div class="col-lg-12 entries">

            <article class="entry entry-single">
              <div class="row">
                <div class="col-9">
                  <h2 class="entry-title">Artículo 15. Información fundamental - Ayuntamientos</h2>
                </div>
                <div class="col-3">
                  <button style="border-radius: 1vh; width: 180px; " *ngIf="boton === 1" (click)="subirDocumento()">
                    Subir documento <i class="bi bi-cloud-arrow-up"></i></button>
                </div>
              </div>

              <div class="entry-content">
                <p style="text-align: justify; font-size: 2vh;">
                  <br><strong>1. Es información pública fundamental de los ayuntamientos:</strong>
                  <br><br><strong> I.</strong><a href="admin/articulo-8" (click)="fraccion1()"> La
                    obligatoria para todos
                    los sujetos obligados.</a>
                  <br><strong>II.</strong><a href="admin/articulo-15/fraccionII" (click)="fraccion2()">La
                    integración del ayuntamiento, las comisiones edilicias y demás órganos que establezca su
                    organigrama.
                  </a> <br><strong>III.</strong><a href="admin/articulo-15/fraccionIII" (click)="fraccion3()">
                    Los bandos de policia y gobierno, reglamentos, decretos, acuerdos, circulares y demás disposiciones
                    jurídicas expedidas por
                    el ayuntamiento respectivo.</a>
                  <br><strong>IV.</strong><a href="admin/articulo-15/fraccionIV" (click)="fraccion4()"> Las
                    iniciativas presentadas y las exposiciones de motivos de los reglamentos vigentes en el municipio.
                  </a><br><strong>V.</strong><a href="admin/articulo-15/fraccionV" (click)="fraccion5()"> Los
                    instrumentos de planeación del desarrollo del municipio y sus modificaciones, de cuando menos los
                    últimos tres años.
                  </a><br><strong>VI.</strong><a href="admin/articulo-15/fraccionVI" (click)="fraccion6()">Los
                    reglamentos internos, manuales y programas operativos anuales de toda dependencia o entidad pública
                    municipal vigentes y
                    de cuando menos los tres años anteriores.</a>
                  <br><strong>VII.</strong><a href="admin/articulo-15/fraccionVII" (click)="fraccion7()">Los
                    programas de trabajo de las comisiones edilicias.</a>
                  <br><strong>VIII.</strong><a href="admin/articulo-8/fraccion-VI/in/i" (click)="fraccion8()"> El
                    orden del día de las sesiones del ayuntamiento, de las comisiones edilicias y de los Consejos
                    Ciudadanos Municipales,
                    con excepción de las reservadas.</a>
                  <br><strong>IX.</strong><a href="admin/articulo-8/fraccion-VI/in/j" (click)="fraccion9()"> EI libro
                    de actas de las sesiones del ayuntamiento, las actas de las comisiones edilicias,
                    así como las actas de los Consejos Ciudadanos Municipales, con excepción de las reservadas.</a>
                  <br><strong>X.</strong><a href="admin/articulo-15/fraccionX" (click)="fraccion10()"> La gaceta
                    municipal y demás órganos de difusión y publicación oficial municipal.
                  </a><br><strong>XI.</strong><a href="admin/articulo-15/fraccionXI" (click)="fraccion11()">La
                    información de los registros públicos que opere, sin afectar la información confidencial contenida.
                  </a> <br><strong>XII.</strong><a href="admin/articulo-15/fraccionXII" (click)="fraccion12()">
                    Los recursos materiales, humanos y financieros asignados a cada dependencia y entidad de la
                    administración pública municipal,
                    detallando los correspondientes a cada unidad administrativa al interior de las mismas.</a>
                  <br> <strong>XIII.</strong><a href="admin/articulo-8/fraccion-VI/in-f" (click)="fraccion13()">
                    Los convenios y contratos celebrados para la realización de obra pública.
                  </a><br> <strong>XIV.</strong><a href="admin/articulo-8/fraccion-VI/in-f" (click)="fraccion14()">
                    Los convenios de coordinación o asociación municipal.</a>
                  <br> <strong> XV.</strong><a href="admin/articulo-8/fraccion-VI/in-f" (click)="fraccion15()"> Los
                    convenios para la prestación de servicios públicos coordinados o concesionados.
                  </a><br><strong> XVI.</strong><a href="admin/articulo-15/fraccionXVI" (click)="fraccion16()">
                    El registro de los consejos consultivos cludadanos,
                    con indicación de la fecha de su creación, funciones que realizan, asi como nombre y cargo de los
                    integrantes.</a>
                  <br><strong>XVII.</strong><a href="admin/articulo-15/fraccionXVII" (click)="fraccion17()"> El
                    registro de las asociaciones
                    de vecinos en el municipio, con indicación de la fecha de creacion, nombre de las mismas,
                    delimitación territorial que representan y datos generales

                    de los miembros de sus directivas, así como de las uniones o federaciones en que se agrupen.</a>
                  <br> <strong> XVIII.</strong><a href="admin/articulo-8/fraccion-V/in-r" (click)="fraccion18()">
                    El registro público de bienes del patrimonio municipal.</a>

                  <br> <strong> XIX.</strong><a href="admin/articulo-15/fraccionXIX" (click)="fraccion19()"> La
                    relación del personal y los inventarios de bienes afectos a cada uno de los servicios publicos
                    municipales, con excepción del servicio de seguridad
                    pública y policía preventiva.</a>
                  <br> <strong> XX.</strong><a href="admin/articulo-15/fraccionXX" (click)="fraccion20()"> EI
                    Programa Municipal de Desarrollo Urbano, los planes de desarrollo urbano de centros de población, y
                    los planes parciales
                    de desarrollo urbano.</a>
                  <br> <strong> XXI. </strong><a href="admin/articulo-15/fraccionXXI" (click)="fraccion21()"> La
                    integración, las actas de las reuniones y los acuerdos del Consejo Municipal de Desarrollo Urbano.
                  </a> <br> <strong> XXII.</strong><a href="admin/articulo-15/fraccionXXII" (click)="fraccion22()"> Las
                    autorizaciones de
                    nuevos fraccionamientos y los cambios de uso de suelo junto con las consultas publicas realizadas
                    con los colonos y la integración del expediente respectivo,
                    en los términos del Código Urbano para el Estado de Jalisco.</a>
                  <br> <strong> XXIII.</strong><a href="admin/articulo-8/fraccion-IV/in-h" (click)="fraccion23()">
                    Los indicadores de evaluación del desempeño.</a>
                  <br> <strong> XXIV.</strong><a href="admin/articulo-15/fraccionXXIV" (click)="fraccion24()">
                    La estadística de asistencias y registro
                    de votación de las sesiones del ayuntamiento, de las comisiones edilicias y de los consejos
                    ciudadanos municipales, que contenga el nombre de los regidores y
                    funcionarios que participan, el sentido del voto y, en su caso, los votos particulares.</a>
                  <br> <strong> XXV.</strong><a href="admin/articulo-15/fraccionXXV" (click)="fraccion25()"> Los
                    ingresos municipales por concepto de participaciones federales
                    y estatales, así como por ingresos propios, que integre la hacienda pública.</a>
                  <br> <strong> XXVI.</strong><a href="admin/articulo-15/fraccionXXVI" (click)="fraccion26()">En
                    su caso la información relativa a la implementación del Presupuesto
                    Participativo desde su planeación hasta su ejecución.</a>
                  <br> <strong>XXVII.</strong><a href="https://www.admin.gob.mx/admin/sesiones" (click)="fraccion27()">
                    Los archivos electrónicos de video y audio de las sesiones del Ayuntamiento.
                  </a><br> <strong>XXVIII.</strong><a href="admin/articulo-15/fraccionXXVIII" (click)="fraccion28()"> La
                    que establezca el Reglamento Interno de Información Pública del Municipio
                    correspondiente.</a>
                </p>

              </div>



            </article>


          </div>

          <div class="col-lg-4">

          </div>
        </div>

      </div>
    </section>

  </main>


  <a href="#" class="back-to-top d-flex align-items-center justify-content-center"><i
      class="bi bi-arrow-up-short"></i></a>

  <!-- Vendor JS Files -->
  <script src="/assets/vendor/aos/aos.js"></script>
  <script src="/assets/vendor/bootstrap/js/bootstrap.bundle.min.js"></script>
  <script src="/assets/vendor/glightbox/js/glightbox.min.js"></script>
  <script src="/assets/vendor/isotope-layout/isotope.pkgd.min.js"></script>
  <script src="/assets/vendor/swiper/swiper-bundle.min.js"></script>
  <script src="/assets/vendor/waypoints/noframework.waypoints.js"></script>
  <script src="/assets/vendor/php-email-form/validate.js"></script>

  <!-- Template Main JS File -->
  <script src="/assets/js/main.js"></script>

</body>

</html>
